import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "order-alert-header" }

import SvgLoader from '@/utils/SvgLoader.vue';
import { onMounted, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HelpIconWithModal',
  props: {
    useTransform: { type: Boolean, default: false }
  },
  setup(__props: any) {

// ヘルプアイコン（モーダル付き）
const result = ref<DOMRect>();
const xLength = ref(0);
const yLength = ref(0);
const isClicked = ref(false);

// ランダムID生成
const imgId = ref<string>('');

const props = __props;

onMounted(() => {
  imgId.value = Math.random().toString(32).substring(2);
});

watch(
  () => isClicked.value,
  () => {
    if (isClicked.value) {
      const element = document.getElementById(imgId.value);
      if (!element) return;
      result.value = element.getBoundingClientRect();
      xLength.value = result.value.left;
      yLength.value = result.value.bottom;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SvgLoader, {
      id: imgId.value,
      class: "order-alert-header__icon",
      name: "questionIcon",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (isClicked.value = !isClicked.value))
    }, null, 8, ["id"]),
    (isClicked.value)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", {
            style: _normalizeStyle({
          top: `${yLength.value}px`,
          left: `${xLength.value - 25}px`,
          transform: props.useTransform ? `translateX(-100%)` : 'translateX(0%)',
        }),
            class: "header-modal"
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 4)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})